var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-cell",on:{"click":_vm.click}},[_c('div',{staticClass:"cell-title"},[_vm._v(_vm._s(_vm.cellTitle))]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }